
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';
import {
  IOrderCheckParams,
  IOrderCheckSettingListItem,
  IUserItem
} from '@/types/orderCheck';
import {
  openFilter,
  getTags,
  getServerList,
  addFilter,
  getFilterList,
  delFilter,
  getOrderCheckSettingList,
  setOrderCheckName,
  editFilter,
  setOrderCheckFlow,
  editFlowUser
} from '@/api/orderCheck';

import { getUserInfo, getUserList } from '@/api/users';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '../../types/permissionType';
import { GroupType } from '@/types/groupType';

@Component({
  name: 'OrderCheckSetting',
  components: {}
})
export default class extends Vue {
  private activeName = 'first';

  private groupType = "";
  private ruleTagShow = true;
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private settingCheckbox = false;
  private settingCondition = false;
  private dialogFormVisible = false;
  private handleClick(val: any) {
    if (Number(val.index) === 1) {
      this.getFilterList();
    } else {
      this.getOrderCheckSettingList();
    }
  }

  private form: any = {};
  private tableData:any = [];
  private activeRuleName = 'rulePrice';
  private radioTag = {};

  private companyAndTags = [];
  private tableDataTag = [];
  private isPriceDot = false;
  private isTagDot = false;
  private dialogTableUsersVisible = false;

  private usersData: IUserItem[] = [];
  private isEditor = false;

  private editData: any = {};
  private SelectedDynamicTags: any[] = [];
  private companyList = [];
  private selectCompanyList = [];
  private selectCompany = {};
  private tableDataSetting: IOrderCheckSettingListItem[] = [];

  private orderCheckParams: IOrderCheckParams = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    page: 1

  };

  private userPage = 1;

  private loadMoreBtnVisible = true;
  private searchForm = {
    name: '',
    departmentName: ''
  };

  private reviewCheckList: number[] = [];

  private userSelectedAll= false;
  private selectUser:any = [];
  private isIndeterminate= null;

  private selectedItem: any = null;

  private first = true;

  private priceChange() {
    if ((this.form as any).price > 0) {
      this.isPriceDot = true;
    } else {
      this.isPriceDot = false;
    }
  }
  private handlePageSizeChange(val: any) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getFilterList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getFilterList();
  }
  private openFilter() {
    let parameters: any = {};
    if (this.settingCondition) {
      parameters.is_check_order_filter = 1;
    } else {
      parameters.is_check_order_filter = 0;
    }
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    if (this.$route.query && this.$route.query.id) {
      parameters.group_id = this.$route.query.id;
    }
    openFilter(parameters)
      .then(res => {
        this.showSecussMsg('保存成功');
        this.showSecussMsg((res as any).msg);
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private searchType=0;
  private handleSearchUser() {
    this.usersData = [];
    this.searchType = 1
    this.getUserList();
  }

  private handleClearUserSearch() {
    this.searchForm.name = '';
    this.searchForm.departmentName = ''
    this.userPage = 1;
    this.usersData = [];
    this.searchForm.name = '';
    this.loadMoreBtnVisible = true;
    this.searchType = 0
    this.getUserList();
  }

  private created() {
    if (this.$route.query && this.$route.query.id) {
      this.orderCheckParams.group_id = this.$route.query.id;
      if(this.$route.query.group_state ){
        this.groupType = this.$route.query.group_state +"";
      }else{
        this.groupType = GroupType.GROUP_DEPARTMENT_CHECK+"" ;
      }
    }
    //增加如果是部门
    if( GroupType.GROUP_CHECK == parseInt(this.groupType) ) {
      this.ruleTagShow = false;
    }else{
      this.ruleTagShow = true;
    }

    this.getOrderCheckSettingList();
  }

  /**
   * 设置审核流程
   */
  private handleSetFlow() {
    let list: any[] = [];
    for (const item of this.tableDataSetting) {
      list.push({
        flow_id: item.reviewId,
        status: this.reviewCheckList.indexOf(item.reviewId) >= 0 ? 1 : 0
      });
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      is_check_order: this.settingCheckbox ? 1 : 0,
      list: JSON.stringify(list)
    };
    if (this.$route.query && this.$route.query.id) {
      params.group_id = this.$route.query.id;
    }
    setOrderCheckFlow(params)
      .then(res => {
        this.showSecussMsg('保存成功');
        this.getOrderCheckSettingList();
        //如果是部门审核及分组审核 返回上一页
        if( checkPermissionCompany(UserModule.getCompanyId, Type.CheckSettingDept) || checkPermissionCompany(UserModule.getCompanyId, Type.CheckSettingGroup)  ){
          this.$router.push({
            path: "/OrderCheck/set",
          });
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
    
  }

  /**
   * 点击调整人员按钮
   */
  private handleSelectUsers(val: any) {
    if (this.$route.query.department_list) {
      (this.$route.query.department_list as any).forEach((element:any) => {
        this.searchForm.departmentName = this.searchForm.departmentName + element.department_name
      });
    }
    // 每次点击从头开始加载
    this.selectedItem = val;
    this.dialogTableUsersVisible = true;
    this.loadMoreBtnVisible = true;
    this.searchType = 2
    this.getUserList();
  }

  private addUser() {
    let p:any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.flow_id = this.selectedItem.reviewId;
    p.step = this.selectedItem.reviewStep;
    p.user_list = JSON.stringify(this.SelectedDynamicTags);
    if (this.$route.query && this.$route.query.id) {
      p.group_id = this.$route.query.id;
    }
    editFlowUser(p)
      .then(res => {
        const data = res.data;
        this.showSecussMsg('添加成功');
        this.dialogUserCancle();
        this.getOrderCheckSettingList();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  /**
   * 人员全选按钮
   */
  private userSelectionAll() {
    if (this.userSelectedAll) {
      // 全选
      for (let i = 0; i < this.usersData.length; i++) {
        let index = this.selectUser.indexOf(this.usersData[i].id);
        if (index === -1) {
          this.selectUser.push(this.usersData[i].id);
          this.SelectedDynamicTags.push(this.usersData[i]);
        }
      }
    } else {
      // 全不选
      this.selectUser = [];
      this.SelectedDynamicTags = [];
    }
  }

  private userSelection(item: any) {
    if (this.selectUser.length > this.SelectedDynamicTags.length) {
      this.SelectedDynamicTags.push(item);
    } else {
      for (let i = 0; i < this.SelectedDynamicTags.length; i++) {
        if (this.SelectedDynamicTags[i].id === item.id) {
          this.SelectedDynamicTags.splice(i, 1);
          break;
        }
      }
    }
  }

  // 弹窗取消
  private dialogUserCancle() {
    this.dialogTableUsersVisible = false;
    this.userSelectedAll = false;
    this.usersData = [];
    this.selectUser = [];
    this.SelectedDynamicTags = [];
    this.searchForm.name = '';
    this.userPage = 1;
  }

  private handleLoadMoreUser() {
    this.userPage += 1;
    this.getUserList();
  }
  /**
   * 获取审核流程列表
   */
  private getOrderCheckSettingList() {
    getOrderCheckSettingList(this.orderCheckParams).then(async res => {
      this.tableDataSetting = [];
      this.reviewCheckList = [];
      this.settingCheckbox = false;
      if (res && res.data) {
        for (const item of res.data.list) {
          let reviewer: IOrderCheckSettingListItem = {
            reviewId: item.id,
            reviewRules: item.name,
            reviewStep: item.step,
            reviewNames: (users => {
              let list = [];
              for (const user of users) {
                let r: IUserItem = {
                  id: user.user_id,
                  name: user.user_name,
                  account: item.account || item.account_mobile,
                  phone: item.mobile,
                  department: item.department_name || '无部门',
                  role: item.role_name
                };
                list.push(r);
              }
              return list;
            })(item.user_list)
          };
          this.tableDataSetting.push(reviewer);
          if (parseInt(item.status) === 1) {
            this.reviewCheckList.push(reviewer.reviewId);
          }
        }
        if (this.$route.query && this.$route.query.id && res.data.group_cs) {
          this.settingCheckbox = parseInt(res.data.group_cs.state) === 1;
        } else {
          await getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
            await UserModule.setLogin(res.data);
            this.settingCheckbox = parseInt((UserModule.getCompany as any).is_check_order) === 1;
          });
        }
      }
    });
  }

  /**
   * 获取工程师列表
   */
  private getUserList() {
    let ids = ""
    if (this.$route.query.department_list) {
      (this.$route.query.department_list as any).forEach((element:any) => {
        ids = ids + element.department_id + ','
      });
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.userPage,
      size: 10,
      user_name: this.searchForm.name,
      module_codes: JSON.stringify([{ module_code: 'ls131000' }]),

    };
    if (this.searchType === 2) {
      params.department_ids = ids
    } else {
      params.department_name = this.searchForm.departmentName
    }
    getUserList(params)
      .then(res => {
        if (res && res.data) {
          if (this.userPage === 1) {
            this.usersData = res.data.list
          } else {
            this.usersData = this.usersData.concat(res.data.list)
          }
          if (this.userPage >= res.data.page_count) {
            this.loadMoreBtnVisible = false;
          } else {
            this.loadMoreBtnVisible = true;
          }
        } else {
          this.loadMoreBtnVisible = false;
        }
        if (this.selectedItem !== null) {
          for (const item of this.selectedItem.reviewNames) {
            let index = this.selectUser.indexOf(item.id);
            if (index === -1) {
              this.selectUser.push(item.id);
              this.SelectedDynamicTags.push(item);
            }
          }
        }
      })
      .catch(err => {
        this.loadMoreBtnVisible = false;
        let msg = err.msg;
      });
  }

  private reviewSettingEditBtn(row: IOrderCheckSettingListItem) {
    this.$prompt('规则名称', '名称编辑', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入规则名称',
      inputValidator: value => {
        if (value.length <= 0) {
          return false;
        }
        return true;
      },
      inputValue: row.reviewRules,
      inputErrorMessage: '请输入正确的规则名称'
    })
      .then(({ value }: any) => {
        const data: any = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          flow_id: row.reviewId,
          name: value
        };
        if (this.$route.query && this.$route.query.id) {
          data.group_id = this.$route.query.id;
        }
        setOrderCheckName(data).then((res: any) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功！'
            });
            this.getOrderCheckSettingList();
          } else {
            this.$message({
              type: 'error',
              message: '修改失败'
            });
          }
        });
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // });
      });
  }

  private handleSelectionChange(val: any) {
    this.SelectedDynamicTags = val;
  }
  private toggleSelection(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.usersData as any).toggleRowSelection(row);
      });
    } else {
      (this.$refs.usersData as any).clearSelection();
    }
  }
  private handleCloseTag(val: any) {
    // this.SelectedDynamicTags.splice(this.SelectedDynamicTags.indexOf(val), 1);
    // for (let index = 0; index < this.usersData.length; index++) {
    //   if (this.usersData[index].id === val.id) {
    //     this.toggleSelection([this.usersData[index]]);
    //   }
    // }
    if (this.selectUser && this.selectUser.length > 0) {
      for (var i = 0; i < this.selectUser.length; i++) {
        if (this.selectUser[i] === val.id) {
          this.selectUser.splice(i, 1);
        }
      }
    }
    if (this.SelectedDynamicTags && this.SelectedDynamicTags.length > 0) {
      for (var m = 0; m < this.SelectedDynamicTags.length; m++) {
        if (this.SelectedDynamicTags[m].id === val.id) {
          this.SelectedDynamicTags.splice(m, 1);
        }
      }
    }
  }
  private closeGuiDialog() {
    this.dialogFormVisible = false;
    this.resetAddfilter();
  }
  private canclePriceAndTags() {
    this.dialogFormVisible = false;
    this.resetAddfilter();
  }
  private addRuleHandle() {
    this.isEditor = false;
    this.dialogFormVisible = true;
    this.getServerList();
  }

  private handleEdit(val: any) {
    this.editData = val;
    this.isEditor = true;
    this.getServerList();
    this.dialogFormVisible = true;
  }
  private handleDelete(val: any) {
    this.$confirm('此操作将删除规则, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delFilter(val.id);
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
  }

  private handleTabClick() {}
  private closeHandle(val: any, index: number, val1: any, index1: number) {
    val1.isChecked = false;
    this.handleConditionTagChange(index1);
    if (
      this.selectCompanyList[index] &&
      (this.selectCompanyList[index] as any).tagsloc &&
      (this.selectCompanyList[index] as any).tagsloc.length > 0
    ) {
      (this.selectCompanyList[index] as any).tagsloc.splice(index1, 1);
    }
    if (
      this.selectCompanyList[index] &&
      (!(this.selectCompanyList[index] as any).tagsloc ||
        (this.selectCompanyList[index] as any).tagsloc.length < 0)
    ) {
      this.selectCompanyList.splice(index, 1);
    }
  }
  private radioChange(val: any, index: number) {
    this.selectCompany = val;
    let ix = -1;
    for (var i = 0; i < this.selectCompanyList.length; i++) {
      if (
        val.servicer_company_id ===
        (this.selectCompanyList[i] as any).servicer_company_id
      ) {
        ix = i;
      }
    }
    this.getTagsByCompanyId(val.servicer_company_id, ix);
  }
  private handleConditionTagChange(index: any) {
    if (!(this.selectCompany as any).tagsloc) {
      (this.selectCompany as any).tagsloc = [];
    }
    let tableDataaa = [];
    if (index.pid && Number(index.pid) !== 0) {
      let a = -1;
      for (var n = 0; n < this.tableDataTag.length; n++) {
        if ((this.tableDataTag[n] as any).tags_id === index.pid) {
          a = n;
        }
      }
      if (a !== -1) {
        for (var i = 0; i < (this.tableDataTag[a] as any).list.length; i++) {
          if ((this.tableDataTag[a] as any).list[i].tags_id === index.tags_id) {
            (this.tableDataTag[a] as any).list[i].isChecked = index.isChecked;
            this.$set(
              (this.tableDataTag[a] as any).list,
              i,
              (this.tableDataTag[a] as any).list[i]
            );
          }
        }
      }
    } else {
      for (var j = 0; j < this.tableDataTag.length; j++) {
        if ((this.tableDataTag[j] as any).tags_id === index.tags_id) {
          (this.tableDataTag[j] as any).isChecked = index.isChecked;
          this.$set(this.tableDataTag, j, this.tableDataTag[j]);
        }
      }
    }
    tableDataaa = this.tableDataTag;
    this.tableDataTag = tableDataaa;
    if (index.isChecked) {
      (this.selectCompany as any).tagsloc.push(index);
    } else {
      (this.selectCompany as any).tagsloc.splice(
        (this.selectCompany as any).tagsloc.indexOf(index),
        1
      );
      if (
        !(this.selectCompany as any).tagsloc ||
        (this.selectCompany as any).tagsloc.length < 1
      ) {
        this.selectCompanyList.splice(
          (this.selectCompanyList as any).indexOf(this.selectCompany),
          1
        );
      }
    }
    if (this.selectCompanyList && this.selectCompanyList.length > 0) {
      let ishave = false;
      for (let i = 0; i < this.selectCompanyList.length; i++) {
        if (
          (this.selectCompanyList[i] as any).servicer_company_id ===
          (this.selectCompany as any).servicer_company_id
        ) {
          (this.selectCompanyList as any).splice(i, 1, this.selectCompany);
          ishave = true;
        }
      }
      if (!ishave) {
        if (index.isChecked) {
          (this.selectCompanyList as any).push(this.selectCompany);
        }
      }
    } else {
      if (index.isChecked) {
        (this.selectCompanyList as any).push(this.selectCompany);
      }
    }
    if (this.selectCompanyList.length > 0) {
      this.isTagDot = true;
    } else {
      this.isTagDot = false;
    }
  }
  private getTagsByCompanyId(companyId: string, index: number) {
    this.tableDataTag = [];
    let parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = companyId;
    getTags(parameters)
      .then(res => {
        if (res && res.data && (res as any).data.list) {
          this.tableDataTag = (res as any).data.list;
          this.setSelectTags(index);
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private setSelectTags(index: number) {
    if (index < 0) {
      return;
    }
    let tableDataTag = [];
    if (
      this.selectCompanyList &&
      this.selectCompanyList[index] &&
      (this.selectCompanyList[index] as any).tagsloc &&
      (this.selectCompanyList[index] as any).tagsloc.length > 0
    ) {
      let tagsloc = (this.selectCompanyList[index] as any).tagsloc;
      for (var m = 0; m < tagsloc.length; m++) {
        if ((tagsloc[m] as any).pid && Number((tagsloc[m] as any).pid) !== 0) {
          let a = -1;
          for (var n = 0; n < this.tableDataTag.length; n++) {
            if (
              (this.tableDataTag[n] as any).tags_id === (tagsloc[m] as any).pid
            ) {
              a = n;
            }
          }
          if (a !== -1) {
            for (
              var i = 0;
              i < (this.tableDataTag[a] as any).list.length;
              i++
            ) {
              if (
                (this.tableDataTag[a] as any).list[i].tags_id ===
                (tagsloc[m] as any).tags_id
              ) {
                (this.tableDataTag[a] as any).list[i].isChecked = true;
                this.$set(
                  (this.tableDataTag[a] as any).list,
                  i,
                  (this.tableDataTag[a] as any).list[i]
                );
              }
            }
          }
        } else {
          for (var j = 0; j < this.tableDataTag.length; j++) {
            if (
              (this.tableDataTag[j] as any).tags_id ===
              ((this.selectCompanyList[index] as any).tagsloc[m] as any).tags_id
            ) {
              (this.tableDataTag[j] as any).isChecked = true;
              this.$set(this.tableDataTag[j], j, this.tableDataTag[j]);
            }
          }
        }
      }
      tableDataTag = this.tableDataTag;
      this.tableDataTag = tableDataTag;
    }
    if (this.selectCompanyList.length > 0) {
      this.isTagDot = true;
    } else {
      this.isTagDot = false;
    }
  }
  private getServerList() {
    let parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    if (
      UserModule.getCompany &&
      (UserModule.getCompany as any).vip_level &&
      String((UserModule.getCompany as any).vip_level).substr(0, 1) === '2'
    ) {
      parameters.service_source = 1;
    }
    parameters.include_branch = 1;
    getServerList(parameters)
      .then(res => {
        this.companyList = (res as any).data.list;
        if (this.isEditor) {
          if (this.companyList && this.companyList.length > 0) {
            if (
              this.editData &&
              this.editData.rule_tags &&
              this.editData.rule_tags.length > 0
            ) {
              this.editorFilterSetData();
            } else {
              if (
                this.editData.rule_pirce && this.editData.rule_pirce.length > 0 && this.editData.rule_pirce[0].price_limit >= 0) {
                this.$set(this.form, 'price', parseFloat(this.editData.rule_pirce[0].price_limit));
                this.isPriceDot = true;
              }
              this.$set(this.form, 'name', this.editData.name);
              this.selectCompany = this.companyList[0];
              this.radioTag = this.companyList[0];
              this.getTagsByCompanyId(
                (this.companyList[0] as any).servicer_company_id,
                0
              );
            }
          }
        } else {
          if (this.companyList && this.companyList.length > 0) {
            this.selectCompany = this.companyList[0];
            this.radioTag = this.companyList[0];
            this.getTagsByCompanyId(
              (this.companyList[0] as any).servicer_company_id,
              0
            );
          }
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private savePriceAndTags() {
    if (!this.form.name) {
      this.showErrorMsg('请输入1-30位规则名称');
      return;
    }
    if (this.form.price && parseInt(this.form.price) <= 0) {
      this.showErrorMsg('请填写正确的价格');
      return;
    }
    if (
      !this.form.price &&
      (!this.selectCompanyList || this.selectCompanyList.length < 0)
    ) {
      this.showErrorMsg('请填写价格或者设置标签');
      return;
    }
    this.addFilter();
  }
  private addFilter() {
    let parameters: any = {};
    let tagsList = [];
    if (this.selectCompanyList && this.selectCompanyList.length > 0) {
      for (var item of this.selectCompanyList) {
        tagsList.push({
          servicer_company_id: (item as any).servicer_company_id,
          tags: (item as any).tagsloc
        });
      }
    }
    if (tagsList.length > 0) {
      parameters.tags_list = JSON.stringify(tagsList);
    }
    parameters.price_limit = this.form.price;
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    parameters.name = this.form.name;
    if (this.$route.query && this.$route.query.id) {
      parameters.group_id = this.$route.query.id;
    }
    if (this.isEditor) {
      parameters.filter_id = this.editData.id;
      editFilter(parameters)
        .then(res => {
          this.dialogFormVisible = false;
          this.getFilterList();
          this.resetAddfilter();
          this.showSecussMsg((res as any).msg);
        })
        .catch(err => {
          this.showErrorMsg(err.msg);
        });
    } else {
      addFilter(parameters)
        .then(res => {
          this.dialogFormVisible = false;
          this.getFilterList();
          this.resetAddfilter();
          this.showSecussMsg((res as any).msg);
        })
        .catch(err => {
          this.showErrorMsg(err.msg);
        });
    }
  }
  private delFilter(filterId: string) {
    let parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    parameters.filter_id = filterId;
    if (this.$route.query && this.$route.query.id) {
      parameters.group_id = this.$route.query.id;
    }
    delFilter(parameters)
      .then(res => {
        this.showSecussMsg((res as any).msg);
        this.getFilterList();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private getFilterList() {
    let parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    parameters.size = this.pagination.pageSize;
    parameters.page = this.pagination.currentPage;
    if (this.$route.query && this.$route.query.id) {
      parameters.group_id = this.$route.query.id;
    }
    getFilterList(parameters)
      .then(async res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.tableData = res.data.list;
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].addtime_str = parseTime(this.tableData[i].addtime, '{y}-{m}-{d} {h}:{i}:{s}');
            this.tableData[i].filter_str = '';
            if (this.tableData[i] && this.tableData[i].rule_pirce && this.tableData[i].rule_pirce.length > 0) {
              if (this.tableData[i].rule_pirce[0].price_limit) {
                this.tableData[i].filter_str = '>=' + this.tableData[i].rule_pirce[0].price_limit;
              }
            }
            if (this.tableData[i] && this.tableData[i].rule_tags && this.tableData[i].rule_tags.length > 0) {
              for (var tag of this.tableData[i].rule_tags) {
                if (tag.condition_name) {
                  this.tableData[i].filter_str = this.tableData[i].filter_str ? this.tableData[i].filter_str + ',' : '' + tag.condition_name;
                }
              }
            }
          }
          this.pagination.total = res.data.count;
        } else {
          this.tableData = [];
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
        }
        if (this.$route.query && this.$route.query.id && res.data.group_cs) {
          this.settingCondition = parseInt(res.data.group_cs.second_state as string) === 1;
        } else {
          await getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
            await UserModule.setLogin(res.data);
            this.settingCondition = parseInt((UserModule.getCompany as any).is_check_order_filter) === 1;
          });
        }
      });
  }
  private editorFilterSetData() {
    if (
      this.editData &&
      this.editData.rule_tags &&
      this.editData.rule_tags.length > 0
    ) {
      let ruleTags = this.editData.rule_tags;
      for (var company of this.companyList) {
        let ruleTagList = [];
        ruleTagList = ruleTags.filter(function(tag: any) {
          return (
            tag.condition_company_id === (company as any).servicer_company_id
          );
        });
        if (ruleTagList.length > 0) {
          for (var itemTag of ruleTagList) {
            if (!(company as any).tagsloc) {
              (company as any).tagsloc = [];
            }
            (company as any).tagsloc.push({
              tags_name: itemTag.condition_name,
              tags_id: itemTag.condition_id,
              pid: itemTag.condition_pid
            });
          }
          this.selectCompanyList.push(company);
        }
      }
    }
    this.selectCompany = this.selectCompanyList[0];
    this.radioTag = this.selectCompanyList[0];
    this.getTagsByCompanyId((this.selectCompany as any).servicer_company_id, 0);
    if (
      this.editData.rule_pirce &&
      this.editData.rule_pirce.length > 0 &&
      this.editData.rule_pirce[0].price_limit >= 0
    ) {
      this.$set(this.form, 'price', parseFloat(this.editData.rule_pirce[0].price_limit));
      this.isPriceDot = true;
    }
    this.$set(
      this.form, 'name', this.editData.name
    );
  }
  private resetAddfilter() {
    this.selectCompanyList = [];
    this.companyList = [];
    this.form = {};
    this.radioTag = {};
    this.companyAndTags = [];
    this.tableDataTag = [];
    this.isPriceDot = false;
    this.isTagDot = false;
    this.selectCompany = {};
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
